import React, { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';

const LatestSidebar = () => {
  const [latestNews, setLatestNews] = useState([]);

  useEffect(() => {
  const fetchLatestNews = async () => {
    try {
      const q = query(collection(db, "news"), orderBy("timestamp", "desc"), limit(20));
      const querySnapshot = await getDocs(q); // এখানে গেট ডকস ব্যবহার করুন
      setLatestNews(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("Error fetching news: ", error);
    }
  };

  fetchLatestNews();
}, []);

  return (
    <div style={{ border: '1px solid #ddd', padding: '15px', height: '500px', overflowY: 'auto' }}>
 <h3 style={{ 
  borderBottom: '2px solid #d2202a', 
  paddingBottom: '5px', // একটু প্যাডিং দিলে বর্ডারের সাথে টেক্সট লেগে থাকবে না
  marginBottom: '20px',  // এই লাইনটিই আপনার কাঙ্ক্ষিত স্পেস তৈরি করবে
  color: '#000', 
  fontSize: '20px' 
}}>
  সর্বশেষ আলোচিত খবর
</h3>
      
      {latestNews.map((news) => (
        <div key={news.id} style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            {/* লাল সার্কেল আইকন */}
            <span style={{ 
              height: '8px', 
              width: '8px', 
              backgroundColor: '#d2202a', 
              borderRadius: '50%', 
              display: 'inline-block',
              marginTop: '6px',
              marginRight: '10px',
              flexShrink: 0
            }}></span>
            
            {/* নিউজ টাইটেল উইথ হভার ইফেক্ট */}
           <Link
to={`/${news.categorySlug || 'general'}/${news.subcategorySlug || 'general'}/${news.id}`}
  style={{ 
    fontSize: '20px', 
    fontWeight: 'bold', 
    textDecoration: 'none', 
    color: '#333', // ডিফল্ট ডিপ ব্ল্যাক
    transition: 'color 0.2s'
  }}
  onMouseOver={(e) => e.target.style.color = '#4169E1'} // হভারে ব্লু
  onMouseOut={(e) => e.target.style.color = '#333333'} // মাউস সরালে আবার ডিপ ব্ল্যাক
>
  {news.title}
</Link>
          </div>
          <small style={{ color: '#888', marginLeft: '20px', display: 'block' }}>{news.date}</small>
        </div>
      ))}
    </div>
  );
};

export default React.memo(LatestSidebar);